import { createAsyncThunk } from "@reduxjs/toolkit";

import { getAccountRequest } from "Api/account/getAccount.request";
import logger from "Libs/logger";

import type { Account } from "Api/account/types";
import type { AsyncThunkOptionType } from "Reducers/types";

export const loadUser = createAsyncThunk<
  Account,
  { userId: string },
  AsyncThunkOptionType
>("app/users/load_user", async ({ userId }, { rejectWithValue }) => {
  try {
    return await getAccountRequest(userId);
  } catch (err) {
    logger(err, {
      action: "loadUser",
      userId
    });

    return rejectWithValue(err);
  }
});
